var _path, _mask, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShowPassword(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 14C10.897 14 10 13.103 10 12C10 10.897 10.897 10 12 10C13.103 10 14 10.897 14 12C14 13.103 13.103 14 12 14ZM12 8C9.794 8 8 9.794 8 12C8 14.206 9.794 16 12 16C14.206 16 16 14.206 16 12C16 9.794 14.206 8 12 8ZM12 19C6.623 19 3.079 13.607 2.142 11.999C3.076 10.389 6.606 5 12 5C17.377 5 20.921 10.393 21.858 12.001C20.924 13.611 17.394 19 12 19ZM12 3C4.469 3 0.28 11.204 0.105 11.553C-0.035 11.834 -0.035 12.166 0.105 12.447C0.28 12.796 4.469 21 12 21C19.531 21 23.72 12.796 23.895 12.447C24.035 12.166 24.035 11.834 23.895 11.553C23.72 11.204 19.531 3 12 3Z",
    fill: "black"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask1",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 3,
    width: 24,
    height: 18
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 14C10.897 14 10 13.103 10 12C10 10.897 10.897 10 12 10C13.103 10 14 10.897 14 12C14 13.103 13.103 14 12 14ZM12 8C9.794 8 8 9.794 8 12C8 14.206 9.794 16 12 16C14.206 16 16 14.206 16 12C16 9.794 14.206 8 12 8ZM12 19C6.623 19 3.079 13.607 2.142 11.999C3.076 10.389 6.606 5 12 5C17.377 5 20.921 10.393 21.858 12.001C20.924 13.611 17.394 19 12 19ZM12 3C4.469 3 0.28 11.204 0.105 11.553C-0.035 11.834 -0.035 12.166 0.105 12.447C0.28 12.796 4.469 21 12 21C19.531 21 23.72 12.796 23.895 12.447C24.035 12.166 24.035 11.834 23.895 11.553C23.72 11.204 19.531 3 12 3Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#432B8D"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShowPassword);
export default __webpack_public_path__ + "static/media/show-password.adb5309d5012fbb0af4c1006172314ef.svg";
export { ForwardRef as ReactComponent };